import { FC } from 'react';
import { useIntl } from 'react-intl';
import { createBemBlockBuilder } from '@ebsco-ui/ebsco-ui';
import EbscoPagination from '@ebsco-ui/pagination';

import { paginationMessages } from '@app/translations';

import './Pagination.scss';

const cnBem = createBemBlockBuilder(['pagination']);

interface PaginationProps {
  pageNumber: number;
  pageCount: number;
  onPageChange: (pageNumber: number) => void;
}

export const Pagination: FC<PaginationProps> = ({
  pageNumber = 0,
  pageCount = 0,
  onPageChange,
}) => {
  const { $t } = useIntl();

  return (
    <EbscoPagination
      activePage={pageNumber}
      count={pageCount}
      previousPageLabel={$t(paginationMessages.previousPage)}
      nextPageLabel={$t(paginationMessages.nextPage)}
      paginationAriaLabel={$t(paginationMessages.pagination)}
      className={cnBem()}
      pageAriaLabel={page => {
        return page === pageNumber
          ? $t(paginationMessages.currentPage, {
              page,
            })
          : $t(paginationMessages.page, {
              page,
            });
      }}
      onSelect={onPageChange}
    />
  );
};
